import { AuthProviderBasic, StoreProvider } from '@encompaas/common';
import { ECSThemeProvider } from '@encompaas/common/themes';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './styles/global.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <AuthProviderBasic>
        <BrowserRouter>
          <ECSThemeProvider>
            <App />
          </ECSThemeProvider>
        </BrowserRouter>
      </AuthProviderBasic>
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
